import { ApiCore } from "../utilities/ApiCore";
import dbConnection from "../utilities/dbConnection";
import { handleError, handleResponse } from "../utilities/Response";

const url = '/uploads'

const apiUploads = new ApiCore({
    get: true,
    url
})

apiUploads.subirConstancia = (evento_id, data) => {
    return dbConnection.put(`/uploads/evento/${ evento_id }`, data, { headers: {'Content-Type': 'multipart/form-data'}})
        .then( handleResponse )
        .catch( handleError );
}

export default apiUploads;